import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const modulesFiles = require.context('./modules', true, /\.store\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // console.log("@@@@@@", modules, modulePath)
  const moduleName = modulePath.replace(/(.*\/)*([^.]+).*/ig, '$2')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})
export default new Vuex.Store({
  modules,
  state: {
  },
  mutations: {
  },
  actions: {
  },

})
